import { lazy, Suspense, useSyncExternalStore } from 'react';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { useGoogleMapsKey } from './useMapData';
import {
  isGoogleMapsLoadRequested,
  markGoogleMapsProviderFailed,
  subscribeToGoogleMapsLoader,
} from './googleMapsLoaderStore';

const DeferredGoogleMapsLoader = lazy(async () => {
  const { GoogleMapsLoader } = await import('./GoogleMapsLoader');
  return { default: GoogleMapsLoader };
});

export function GoogleMapsLoaderHost() {
  const apiKey = useGoogleMapsKey();
  const loadRequested = useSyncExternalStore(
    subscribeToGoogleMapsLoader,
    isGoogleMapsLoadRequested,
    () => false,
  );

  if (!loadRequested || !apiKey) return null;

  return (
    <RpErrorBoundary fallback={<></>} onError={markGoogleMapsProviderFailed}>
      <Suspense fallback={null}>
        <DeferredGoogleMapsLoader apiKey={apiKey} />
      </Suspense>
    </RpErrorBoundary>
  );
}
